import { render } from '@testing-library/react';

export const renderForTest = (component: any) => {
  return render(component);
};
